import React from "react";
import MyDonationPayments from "./MyDonationPayments";
import WebService from "api/explus-api";

class MyDonationPaymentsContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            payments: {
                data: []
            },
            loading: false
        };
        this.getPayments = this.getPayments.bind(this);
        this.getPaymentsByFunction = this.getPaymentsByFunction.bind(this);
    }

    componentDidMount() {
        this.getPaymentsByFunction();
    }

    getPaymentsByFunction() {
        this.setState({ loading: true });

        WebService.ajaxGet("web/payments").then(data => {
            this.setState({ payments: data });
            this.setState({ loading: false });

            if (data.data[0] !== undefined) {
                const paymentId = data.data[0].payment_method.method_id;

                if (
                    paymentId === 3 ||
                    paymentId === 47 ||
                    paymentId === 48 ||
                    paymentId === 28 ||
                    paymentId === 38 ||
                    paymentId === 33
                ) {
                    // hide deposit slip upload if credit cards
                    this.props.hideDeposit(false);
                }
            }
        });
    }

    isLoading() {
        if (this.state.loading === false) {
            this.setState({ loading: true });
        } else {
            this.setState({ loading: false });
        }
    }

    getPayments(pageNumber) {
        return event => {
            event.preventDefault();
            this.isLoading();

            WebService.ajaxGet("web/payments", pageNumber).then(data => {
                this.setState({ payments: data });
                this.isLoading();
            });
        };
    }

    render() {
        return (
            <MyDonationPayments
                loading={this.state.loading}
                payments={this.state.payments}
                handler={this.getPayments}
            />
        );
    }
}

export default MyDonationPaymentsContainer;
